import { BASE_API_URL } from "utils/constants";
import { downloadFilePost, post } from '../../utils/api';
import { DataResponse } from "services/response";


// ============================BÁO CÁO TỔNG HỢP xlkn 3 MIỀN=====================================
export interface THXLKN3MModel {
    section: string
    sthxlkn: DataMonth
    gtsp: DataMonth
    gtbh: DataMonth
    gtgt: DataMonth
}

export interface DataMonth {
    t1: number
    t2: number
    t3: number
    t4: number
    t5: number
    t6: number
    t7: number
    t8: number
    t9: number
    t10: number
    t11: number
    t12: number
    total: number
}

// ============================BÁO CÁO SO SÁNH XLKN 3 MIỀN=====================================
export interface SSXLKN3MModel {
    stt: number
    khuVuc: string
    soTHXLKNKyTruoc: number
    gtspKyTruoc: number
    gtbhKyTruoc: number
    gtggKyTruoc: number
    tyLeKyTruoc: number
    soTHXLKNKyBC: number
    gtspKyBC: number
    gtbhKyBC: number
    gtggKyBC: number
    tyLeKyBC: number
    tyLeGiua2Ky: number
}

// ================================BÁO CÁO tỔNG HỢP XLKN 3 MIỀN=================================================================


// ============ Khai báo phương thức =====================
// Báo cáo bảo hành và khiếu nại
export interface IReportWAndCServices {
    // Báo cáo tổng hợp xử lý khiếu nại 3 miền
    getDataReportTHXLKN3M(data: object): Promise<DataResponse<Array<THXLKN3MModel>>>
    // Xuất Excel báo cáo hợp xử lý khiếu nại 3 miền
    exportExportReportTHXLKN3M(dataSearch: Object): Promise<void>
    // Báo cáo so sánh xử lý khiếu nại 3 miền
    getDataReportSSXLKN3M(data: object): Promise<DataResponse<Array<SSXLKN3MModel>>>
    // Xuất Excel báo cáo so sánh XLKN3M
    exportExportReportSSXLKN3M(dataSearch: Object): Promise<void>
}
// Hàm khởi tạo các phương thức của Báo cáo bảo hành và khiếu nại service
export function createReportWAndCServices(): IReportWAndCServices {
    return {
        getDataReportTHXLKN3M: async (data) => {
            return (
                await post(
                    BASE_API_URL,
                    `Reports/report-thxlkn3m`, data))
                .data;
        },
        // Xuất Excel báo cáo tổng hợp xử lý khiếu nại 3 miền
        exportExportReportTHXLKN3M: async (dataSearch) => {
            await downloadFilePost(`Reports/export-excel-thxlkn3m`, dataSearch);
        },
        // Báo cáo so sánh xử lý khiếu nại 3 miền
        getDataReportSSXLKN3M: async (data) => {
            return (
                await post(
                    BASE_API_URL,
                    `Reports/report-xlkn`, data))
                .data;
        },
        // Xuất Excel báo cáo so sánh XLKN3M
        exportExportReportSSXLKN3M: async (dataSearch) => {
            await downloadFilePost(`Reports/export-excel-ssxlkn3m`, dataSearch);
        }
    };
}
